import { render, staticRenderFns } from "./LinksView.vue?vue&type=template&id=2bd35125&scoped=true&"
import script from "./LinksView.vue?vue&type=script&lang=js&"
export * from "./LinksView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd35125",
  null
  
)

export default component.exports